<template>
  <div class="card card-user">
    <div class="image">
      <img src="static/img/test_wide.jpg" alt="...">
    </div>
    <div class="card-content">
      <div class="author">
        <img class="avatar border-white" src="static/img/new_profile_pic.jpg" alt="...">
        <h4 class="title">Michael Clemens</h4>
        <p class="title" style="font-size:20px;margin-top:-20px;">
          <br>
          <a href="https://twitter.com/mclemcrew" target="_blank" >
            <small>@mclemcrew <span style="font-style: italic;">- Twitter</span></small>
          </a>
        </p>
        <p class="title" style="font-size:20px;margin-top:-20px;">
          <br>
          <a href="https://www.instagram.com/mclemcrew/?hl=en" target="_blank">
            <small>@mclemcrew <span style="font-style: italic;">- Instagram</span></small>
          </a>
        </p>
        <p class="title" style="font-size:20px;margin-top:-20px;margin-bottom:20px">
          <br>
          <a href="https://www.youtube.com/channel/UCcJPZgexRnEeMnLvlqlfF0w" target="_blank">
            <small>@mclemcrew <span style="font-style: italic;">- YouTube</span></small>
          </a>
        </p>
      </div>
      <p class="description text-center">
        <em>"If it doesn't glow, I probably didn't make it."</em>
      </p>
      <p class="description text-center" style="margin-top:25px">
        <em>Avatar artwork created by: <a href="https://www.instagram.com/soulmusing/" target="_blank">soulmusing</a></em>
      </p>
    </div>
    <hr>
  </div>
</template>
<script>
  export default {
    methods: {
      getClasses (index) {
        const remainder = index % 3
        if (remainder === 0) {
          return 'col-md-3 col-md-offset-1'
        } else if (remainder === 2) {
          return 'col-md-4'
        } else {
          return 'col-md-3'
        }
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/UserCard.vue